import { useEffect } from "react";

const useWebOtp = (onCode: (digits: string[]) => void) => {
  useEffect(() => {
    if ("OTPCredential" in window && (navigator as any).credentials) {
      const controller = new AbortController();
      (navigator as any)
        .credentials.get({
          //@ts-ignore
          otp: { transport: ["sms"] },
          signal: controller.signal,
        })
        .then((otp: any) => {
          if (otp && otp.code) {
            const digits = otp.code
              .replace(/\D/g, "")
              .slice(0, 5)
              .split("")
              .reverse();
            onCode(digits);
          }
        })
        .catch(() => {});
      return () => controller.abort();
    }
  }, [onCode]);
};

export default useWebOtp;
